module.exports = __webpack_public_path__ + "img/twoGreen.3c656798.jpg";